import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';
export const addResearchData = async (formDataToSend) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addResearch`,
            formDataToSend,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editResearchData = async ( id, formDataToSend) => {
    try {
        const response = await ApiClient.put(`/researchandstudentlife/updateResearch/${id}`,
            formDataToSend,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteResearchData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deleteResearch/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getResearchData = async () => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getResearch`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}
